import { ApiService } from ".";
import { IFoldersApiService } from "./IFoldersApiService";
import { PagedModel } from "../models/PagedModel";
import { SimpleFolderModel } from "../models/SimpleFolderModel";

export class FoldersApiService extends ApiService implements IFoldersApiService {
    constructor(baseUrl: string, language?: string) {
        super(baseUrl, language);
    }

    public getFolderList(
        nameFilter: string = "",
        pathFilter: string = "",
        page: number = 1,
        perPage: number = 25,
        sortField: "Name" | "Type" | "Path" = "Path",
        sortDirection: "ascending" | "descending" = "ascending"
    ): Promise<PagedModel<SimpleFolderModel>> {
        return this.get<PagedModel<SimpleFolderModel>>("folders", {
            name: nameFilter,
            path: pathFilter,
            page,
            perPage,
            sortField,
            sortDirection,
        });
    }

    public getFolderDetails(id: string): Promise<SimpleFolderModel> {
        const [folderId, path] = id.split("-");
        const param = path ? "?pathhash=" + encodeURIComponent(path) : "";
        return this.get<SimpleFolderModel>(`folders/${folderId}${param}`);
    }
}
